import { AfterViewInit, Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { GenericChatTypesUi, GenericStreamListForUserUse, GenericUserStreamResult, GenericUserStreamWithProgress } from '../../interfaces/responsedata.ts/generic-streams';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { GenericResultViewComponent } from '../../home/user/generic-stream/generic-result-view/generic-result-view.component';
import { InternLandingPageComponent } from '../../components-track/intern-landing-page/intern-landing-page.component';
import { GenAiService } from '../../service/gen-ai.service';
import { GenericStreamService } from '../../service/generic-stream.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-generic-stream-result',
    standalone: false,
    templateUrl: './generic-stream-result.component.html',
    styleUrl: './generic-stream-result.component.scss'
})
export class GenericStreamResultComponent implements OnInit {
    @Input({ required: true })
    public streamData!: GenericStreamListForUserUse;

    @Input({ required: true })
    public userStream!: GenericUserStreamWithProgress;

    @Input({ required: true })
    public userId!: string;

    @Input({ required: false })
    public isCoachAccess: boolean = false;

    @Output()
    public isLoading: EventEmitter<boolean> = new EventEmitter<boolean>();

    private destroyRef = inject(DestroyRef);
    private dialog = inject(MatDialog);
    private ai = inject(GenAiService);
    private genService = inject(GenericStreamService);
    private sanitizer = inject(DomSanitizer);

    protected showChatSummaries: boolean = false;
    finalAssets: GenericUserStreamResult[] = [];
    steResults: GenericUserStreamResult[] = [];

    ngOnInit(): void {
        // console.log("sd",this.streamData)
        // console.log("us",this.userStream)
        let stepresults = this.userStream.results;
        let streamResults = []
        if (this.streamData?.streamResults) {
            streamResults = JSON.parse(JSON.stringify(this.streamData?.streamResults));
        } else {
            streamResults = this.userStream.results.filter(s => s.type === 'stream-result');
        }
        let streamResultList: GenericUserStreamResult[] = [];
        for (let sr of streamResults) {
            if (this.isCoachAccess === true) {
                streamResultList.push(sr);
                continue;
            }
            const matchedStepResult = stepresults.find(result => result.variant === sr.type && result.type === 'stream-result');
            if (matchedStepResult) {
                streamResultList.push(matchedStepResult);
            } else {
                let srResult: GenericUserStreamResult = {
                    stepId: new Date().getTime().toString(),
                    name: sr.title,
                    type: 'stream-result',
                    variant: sr.type,
                    data: undefined
                }
                streamResultList.push(srResult);
                    this.createRessource(srResult);
            }
        }

        this.finalAssets = streamResultList || []
        this.steResults = stepresults.filter(r => r.type === "step-result");
    }

    protected async createRessource(item: GenericUserStreamResult): Promise<void> {
        let result = await this.ai.genericStreamClosingAiPost(
            this.userStream!.id,
            item.variant!
        )
        if (result === false) {
            return;
        }

        const newResultObject: GenericUserStreamResult = {
            created: new Date().getTime(),
            stepId: item.stepId,
            name: item.name,
            type: "stream-result",
            variant: item.variant,
            data: result.result

        }
        this.userStream?.results.push(newResultObject);

        for (let sr of this.finalAssets) {
            if (sr.variant === item.variant && !sr.created) {
                sr.created = newResultObject.created;
                sr.data = newResultObject.data;
            }
        }


        const cleanObject = this.userStream.results.filter(r => r.data !== undefined);
        this.userStream.results = cleanObject;

        await this.genService.updateGenericUserStreamResults(this.userStream!.id, this.userStream?.results || []);
    }

    protected openRessource(item: any): void {
        // console.log("ITEM TO SHOW", item)
        if (item.variant === "CLS_LP") {
            this.openInternLandingPage(item.refId);
            return;
        }

        if (item.variant.indexOf("CLS_HTML_") !== -1) {
            this.openHtmlRessource(item);
            return;
        }

        let dia = this.dialog.open(
            GenericResultViewComponent,
            { data: { ...item, streamId: this.userStream?.id, isCoachAccess: this.isCoachAccess }, autoFocus: false, disableClose: true }
        );

        dia.afterClosed()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(result => {
                if (!result) return;

                this.handleResultItemEvents(result)
            });
    }

    private openHtmlRessource(data: any): void {
        const url = `generic-stream/editable/view?uid=${this.userId}&sid=${this.userStream.id}&stepid=${data.stepId}`;
        const newWindow = window.open('', '_blank');

        if (newWindow) {
            newWindow.location.href = url;
        }
    }

    private openInternLandingPage(refId: string): void {
        this.dialog.open(InternLandingPageComponent, {
            panelClass: "feed-back-card",
            data: { projectId: refId }
        });
    }

    private async handleResultItemEvents(eventData: { type: string, resultData: any }): Promise<void> {
        if (eventData.type === "export-miro") {
            this.isLoading.emit(true);

            await this.ai.genAiMiroExport(eventData.resultData.data);

            this.isLoading.emit(false);
        }

        if (eventData.type === "download-pdf") {
            // createFile
            this.isLoading.next(true);

            const file = await this.genService.createFileFromResultData(
                eventData.resultData.name,
                eventData.resultData.data,
                eventData.resultData.type,
                eventData.resultData.variant,
            );

            this.isLoading.next(false);

            if (file === false) {
                return;
            }

            this.userStream.results.forEach(r => {
                if (r.stepId === eventData.resultData.stepId) {
                    r.fileId = file.fileData.id;
                    r.file = {
                        "id": file.fileData.id,
                        "fileName": file.fileData.identifer,
                        "fileSize": file.fileData.size,
                        "dateCreated": new Date().getTime()
                    };

                }

            })

            // Download/Open PDF in file.buffer Object
            this.handlePDFBuffer(file, "download");

            if (this.isCoachAccess === false) {
                this.genService.updateGenericUserStreamResults(this.userStream!.id, this.userStream?.results);
            }
        }

        if (eventData.type === "close") {
            // Actually no case
        }

        if (this.isCoachAccess === false) {
            this.userStream?.results.forEach(result => {
                if (result.stepId === eventData.resultData.stepId) {
                    result.data = eventData.resultData.data;
                    this.genService.updateGenericUserStreamResults(this.userStream!.id, this.userStream?.results);
                }
            });
        }
    }

    private handlePDFBuffer(
        file: any,
        action: 'download' | 'open' | 'inline' = 'download',
    ): void {
        try {
            if (!file || !file.buffer) {
                console.error('Kein Buffer gefunden');
                return;
            }

            let bufferData = file.buffer;

            if (bufferData.type === 'Buffer' && bufferData.data) {
                bufferData = new Uint8Array(bufferData.data);
            }

            const blob = new Blob([bufferData], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            switch (action) {
                case 'download':
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = file.fileData.identifer || `document_${Date.now()}.pdf`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    break;

                case 'open':
                    window.open(url, '_blank');
                    break;

                case 'inline':
                    this.sanitizer.bypassSecurityTrustResourceUrl(url);
                    break;
            }

            // Cleanup
            if (action !== 'inline') {
                setTimeout(() => window.URL.revokeObjectURL(url), 100);
            }

        } catch (error) {
            console.error('Fehler beim Verarbeiten des PDF-Buffers:', error);
        }
    }
}
